export default __webpack_public_path__ + "static/media/kitchen4-afterC-1920w.7fc65902.webp";